import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Haluatko varmasti poistaa käytöstä live-tilaukset?',
    enable: 'Haluatko varmasti ottaa käyttöön live-tilaukset?',
  },
  form: {
    delivery_app_sales_at_go_live: {
      label: 'Kuukausittainen myynti toimitussovelluksissa',
      description:
        'Kokonaiskuukausimyynti kaikissa toimitussovelluksissa (Lieferando, Wolt, Uber Eats…) kokonaislukuna. Syötä 0, jos ravintola ei myy niissä lainkaan. Käyttöönoton jälkeen vain ylläpitäjä voi muuttaa sitä.',
      placeholder: 'Syötä kuukausittainen summa',
    },
    is_google_business_available: {
      label: 'Google Business saatavilla',
    },
    is_smart_pricing_configured: {
      label: 'Halvemmat hinnat kuin Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Mainoslehtinen lähetetty',
    },
    is_menu_fully_configured: {
      label: 'Kaikki valikon tuotteet saatavilla',
    },
    has_offers_on_competitor_platforms: {
      label:
        'Onko ravintolalla käynnissä tarjouksia Woltissa, Uberissa, Lieferandossa (paitsi ilmainen toimitus -tarjous)?',
    },
    is_instagram_story_shared: {
      label: 'Instagram-tarina jaettu omistajalle',
    },
    is_order_system_connected_to_website: {
      label: 'Foodamigos-verkkosivusto yhdistetty TAI ravintolan omaan verkkosivustoon lisätty verkkotilauspainike',
    },
    google_business_connected_by: {
      label: 'Miten saimme pääsyn Google Business -profiiliin?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Myyntipäällikkö kutsui google@foodamigos.io:n',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Myyntipäällikkö lähetti ensimmäisen pyynnön itse omistajan puhelimesta',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Käyttöönottopäällikkö pyysi Google Business -profiilia (myyntipäällikkö ei kutsunut eikä pyytänyt pääsyä)',
      },
    },
  },
  labels: {
    successful_launch:
      'Jotta käynnistys onnistuu, tarkista ja käsittele seuraavat avoimet kohdat. Tämän tiedon vieminen\n' +
      'läpi auttaa välttämään mahdollisia ongelmia, kun ravintola on live-tilassa.',
    check_errors: 'Tarkista virheet varmistaaksesi ravintolan onnistuneen käynnistyksen.',
    checkbox_confirmation: 'Vahvistan, että olen tarkistanut virheet ja hyväksyn tämän ravintolan aktivoinnin.',
  },
  buttons: {
    check_error: 'Tarkista virhe',
    confirm_and_activate: 'Vahvista ja aktivoi',
    cancel: 'Peruuta',
    yes: 'Kyllä',
    no: 'Ei',
  },
  errors: {
    name: {
      title: 'Ei arabian-, kiinan- tms. merkkejä kaupan nimessä',
      description: 'Verkkokaupan nimi sisältää muita kuin englantilaisia (latinalaisia) merkkejä',
    },
    logo_url: {
      title: 'Logo',
      description: 'Logo on ladattu verkkokauppaan',
    },
    pictures: {
      title: 'Galleriakuva',
      description: '≥ 1 galleriakuva saatavilla verkkokaupassa',
    },
    menu_uploaded: {
      title: 'Valikko ladattu',
      description: '≥ 1 valikko saatavilla',
    },
    opening_hours: {
      title: 'Aukioloajat',
      description: '≥ 1 aukioloaika lisätty',
    },
    address: {
      title: 'Ravintolan osoite',
      description: 'Katu, kaupunki, postinumero syötetty',
    },
    upsell_items: {
      title: 'Lisämyyntituotteet',
      description: '≥ 3 lisämyyntituotetta valittu',
    },
    master_promo_code: {
      title: 'Pääalennuskoodi',
      description: 'Pääalennuskoodi saatavilla',
    },
    flyers_ordered: {
      title: 'Mainoslehtiset tilattu',
      description: '≥ 1 mainoslehtispaketti tilattu',
    },
    test_orders: {
      title: 'Testitilaus lähetetty',
      description: '≥ 1 testitilaus tehty',
    },
    stripe_billing: {
      title: 'Stripe-tili',
      description: 'Stripe-tili yhdistetty',
    },
    payments_configured: {
      title: 'Maksut määritetty',
      description: 'Partneri on yhdistänyt maksupalveluntarjoajan — vaaditaan ennen julkaisua',
    },
    adyen_merchant_account: {
      title: 'Adyen-kauppiastili',
      description: 'Aktiivinen kauppiastili tälle ravintolan maalle — vaaditaan kotimaisia korttihintoja varten',
    },
    payment_rail_covers_country: {
      title: 'Maksukanava kattaa maan',
      description: 'Partnerin maksutilit voivat käsitellä tämän ravintolan maata',
    },
    identity: {
      title: 'Ravintolan identiteetti',
      description: 'Ravintolan tyyppi ja keittiö on asetettu',
    },
    storefront: {
      title: 'Storefront luotu ja verkkotunnus yhdistetty',
      description: 'Vain jos ravintola haluaa käyttää verkkosivustoamme',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business yhdistetty',
    },
    billing_payment_method: {
      title: 'Maksutapa',
      description: 'Lisää maksutapa, jotta FoodAmigos voi laskuttaa tätä ravintolaa kuukausittain.',
    },
    billing_license: {
      title: 'Lisenssi',
      description: 'Tämä ravintola tarvitsee Partner Plan -tilauksen ennen julkaisua.',
    },
    business_name: {
      title: 'Yrityksen/ravintolan nimi',
      description: 'Käyttöehdoissa ja tietosuojakäytännössä näkyvä nimi on tallennettu',
    },
    payment_method: {
      title: 'Käteis- tai verkkomaksut',
      description: 'Käteismaksu noudossa tai toimituksessa on käytössä, tai verkkomaksut on vahvistettu',
    },
    stripe_processing_fee: {
      title: 'Käsittelymaksu',
      description: 'Kumppani on asettanut Stripe-käsittelymaksunsa tai vahvistanut 0 %:n marginaalin',
    },
  },
};
